export default function fileUpload() {

	let files = document.querySelectorAll('.default-input__input--file');
	if (!files)
		return;
	files.forEach((file) => {
		let fileInput = file;
		let fileLabel = fileInput.parentElement.querySelector('.default-input__label--file');
		if (fileInput) {
			fileInput.onchange = function () {
				fileLabel.innerHTML = this.files[0].name;
			}

		}
	})


}